<template>
  <div class="gradient-row">
    <div class="changelog">
      <div class="log-content" v-loading="loading" element-loading-background="
        rgba(255, 255, 255, 0.9)
      ">
        <h4>交流反馈</h4>
        <!-- <p>qq群：{{ changelog.qqGroup }}</p> -->
        <p>
          电报群：
          <a :href="changelog.tgGroup" target="_blank" rel="noopener noreferrer">{{ changelog.tgGroup }}</a>
        </p>
        <!-- <p>微信群二维码</p>
        <div ref="qrcode" id="qrcode"></div> -->
        <h4>更新日志</h4>
        <ul>
          <li v-for="el in changelog.list" :key="el.version">
            <h5>
              v{{ el.version }}
              <span class="btn primary" v-if="el.type == 2">重要更新</span>
            </h5>
            <ul>
              <li :class="i.type == 2 ? 'major' : ''" v-for="(i, ind) in el.content" :key="ind">
                {{ i.content }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      updateurl: {
        github: "https://x2rr.github.io/funds/src/common/changeLog.json",
        gitee: "https://rabt.gitee.io/funds/src/common/changeLog.json",
      },
      centerDialogVisible: false,
      qrcode: false,
      changelog: {},
      loading: false,
    };
  },
  mounted() {
    this.getChangelog();
  },
  methods: {
    getChangelog() {
      this.loading = true;
      let domain = window.location.host;
      // let domain = "funds.rabt.top";
      let timestamp = new Date().getTime();
      let range = 1 * 60 * 1000;
      timestamp = Math.floor(timestamp / range) * range;
      let url = "https://" + domain + "/funds/src/common/changeLog.json?t=" + timestamp;
      this.$axios.get(url).then((res) => {
        this.loading = false;
        this.changelog = res.data;
        this.setQrcode();
      });
    },
    init() {
      this.centerDialogVisible = true;
      this.getChangelog();
    },
    setQrcode() {
      if (!this.qrcode) {
        this.qrcode = new QRCode("qrcode", {
          width: 180,
          height: 180, // 高度
          text: this.changelog.qrcode, // 二维码内容
        });
      }
    },

    close() {
      if (this.qrcode) {
        this.qrcode.clear();
      }
      this.$refs.qrcode.innerHTML = null;
      this.centerDialogVisible = false;

      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.changelog {
  max-width: 600px;
  padding: 20px;
  margin: 0 auto;

  #qrcode {
    text-align: center;
    width: 180px;
    height: 180px;
    padding: 6px;
    margin: 10px auto 0;
    background-color: #fff;
  }

  .log-content {
    min-height: 900px;

    p {
      text-align: center;
      margin: 0;
      padding: 3px 0;
    }

    h4 {
      font-size: 30px;
      margin: 40px 0 30px;
    }

    ul {
      padding-left: 22px;
      padding-bottom: 40px;
      margin: 5px 0;
      text-align: left;

      li {
        padding: 3px 0;

        .major {
          font-weight: bold;
        }

        h5 {
          margin: 10px 0;
          font-size: 15px;
          font-weight: bold;
        }
      }
    }

    .btn {
      display: inline-block;
      line-height: 1;
      background: #fff;
      padding: 4px 6px;
      border-radius: 3px;
      font-size: 12px;
      color: #000000;
      margin: 0 3px;
      outline: none;
      border: 1px solid #dcdfe6;
    }

    .primary {
      color: #409eff;
      border-color: #409eff;
    }
  }
}
</style>
